import { Input } from '@progress/kendo-react-inputs';
import React, { useState, useEffect } from 'react';
import AddFolderDialog from '../../../../asite-relatics/components/ConfigurationFolders/AddFolderDialog';
import FolderTreeWithInputData from '../../ConfigurationDocumentLink/components/FolderTreeWithInputData';

function clearDependencyAttributes(dataItem: any) {
    delete dataItem?.organisation;
    delete dataItem?.phase;
    delete dataItem?.documentType;
    delete dataItem?.workpackage;
    delete dataItem?.documentType;
    delete dataItem?.status;
    delete dataItem?.disciplineCode;
}

const PathFolderModal = ({
    field,
    dataItem,
    dataIndex,
    onChange,
    required,
    maxChars,
    title,
    pattern,
    ...props
}: any) => {
    const [newFolderModalVisible, setNewFolderModalVisible] = useState(false);

    const [selectedPath, setSelectedPath] = useState();
    const handleChange = (e: any) => {
        const item = { ...dataItem, [field!]: e };

        if (!props?.linkDirectory) clearDependencyAttributes(item);

        onChange!({
            dataItem: item,
            field: field,
            value: selectedPath as any,
            dataIndex: dataIndex,
        });
    };

    useEffect(() => {
        if (selectedPath as any) {
            handleChange(selectedPath as any);
        }
    }, [selectedPath as any]);

    return (
        <>
            {props?.pathList && props?.pathList.length > 0 ? (
                <FolderTreeWithInputData
                    newFolderModalVisible={newFolderModalVisible}
                    setNewFolderModalVisible={setNewFolderModalVisible}
                    setSelectedPath={setSelectedPath}
                    pathList={props?.pathList}
                />
            ) : (
                <AddFolderDialog
                    newFolderModalVisible={newFolderModalVisible}
                    setNewFolderModalVisible={setNewFolderModalVisible}
                    singleSelect={true}
                    setSelectedPath={setSelectedPath}
                />
            )}
            {dataItem.inEdit ? (
                <Input
                    {...props}
                    required={required}
                    pattern={pattern}
                    value={dataItem[field!]?.fullPath}
                    onChange={handleChange}
                    maxLength={maxChars}
                    onClick={(e) => {
                        setNewFolderModalVisible(true);
                    }}
                    autoComplete={'off'}
                />
            ) : (
                <span title={title}>{dataItem[field!]?.fullPath}</span>
            )}
        </>
    );
};
export default PathFolderModal;
